import React from 'react';

import Typography from '../../../../../../_ui/_blocks/Typography/Typography';

interface Props {
    children: React.ReactNode;
}

const FilterLabel = ({ children }: Props) => (
    <Typography typeset="subheading" size="090" lineHeight="none" className="flex items-center gap-050">
        {children}
    </Typography>
);

export default FilterLabel;
